import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { Checkbox, TableRow, TableCell, IconButton } from '@mui/material';

import { useAuth } from 'src/hooks/useAuth';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import getDisplayName from 'src/utils/getDisplayName';
import { convertLocalTime } from 'src/utils/convertTime';

import Iconify from 'src/components/iconify';

function TagRow({ tag, isItemSelected, handleClick, handleOpenMenu, onRowClick }) {
  const { isSmallScreen } = useResponsiveScreen();
  const { role } = useAuth();
  return (
    <TableRow
      selected={isItemSelected}
      sx={{ cursor: 'pointer' }}
      hover
      onClick={() => onRowClick(tag)}
    >
      <TableCell padding="checkbox">
        <Checkbox
          checked={isItemSelected}
          onClick={(event) => event.stopPropagation()}
          onChange={(event) => handleClick(event, tag.id)}
          sx={{
            '.MuiSvgIcon-root': {
              width: isSmallScreen ? 18 : 24,
              height: isSmallScreen ? 18 : 24,
            },
          }}
        />
      </TableCell>
      <TableCell
        sx={{
          fontSize: isSmallScreen && '0.65rem',
        }}
      >
        #{tag.id}
      </TableCell>
      <TableCell
        sx={{
          fontSize: isSmallScreen && '0.65rem',
        }}
      >
        {tag.name}
      </TableCell>
      <TableCell
        sx={{
          fontSize: isSmallScreen && '0.65rem',
        }}
        align={tag.description ? 'left' : 'center'}
      >
        {tag.description || '-'}
      </TableCell>
      {role.authority === 'ROLE_ADMIN' && (
        <>
          <TableCell
            sx={{
              fontSize: isSmallScreen && '0.65rem',
            }}
            align="center"
          >
            {tag.department ? tag.department.name : '-'}
          </TableCell>
          <TableCell
            sx={{
              fontSize: isSmallScreen && '0.65rem',
            }}
            align="center"
          >
            {tag.createdBy ? getDisplayName(tag.createdBy) : '-'}
          </TableCell>
        </>
      )}
      <TableCell
        sx={{
          fontSize: isSmallScreen && '0.65rem',
        }}
        align="center"
      >
        {format(convertLocalTime(new Date(tag.createdAt)), 'dd/MM/yyyy HH:mm:ss')}
      </TableCell>
      <TableCell
        sx={{
          fontSize: isSmallScreen && '0.65rem',
        }}
        align="center"
      >
        {tag.updatedAt
          ? format(convertLocalTime(new Date(tag.updatedAt)), 'dd/MM/yyyy HH:mm:ss')
          : '-'}
      </TableCell>
      <TableCell
        align="center"
        sx={{
          position: 'sticky',
          zIndex: '100',
          right: 0,
          backgroundColor: 'white',
        }}
      >
        <IconButton
          size={isSmallScreen ? 'small' : 'large'}
          color="inherit"
          onClick={(event) => {
            event.stopPropagation();
            handleOpenMenu(event, tag);
          }}
        >
          <Iconify
            icon="eva:more-vertical-fill"
            sx={{
              width: 20,
              height: isSmallScreen ? 16 : 20,
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

TagRow.propTypes = {
  tag: PropTypes.object,
  isItemSelected: PropTypes.bool,
  handleClick: PropTypes.func,
  handleOpenMenu: PropTypes.func,
  onRowClick: PropTypes.func,
};

export default TagRow;
